import {Component, OnInit, ViewChild} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {UITableComponent} from '../framework/ui/table';
import {QARService, SystemRoleEntity, SystemRoleWithClashCountResult} from '../services/qar.service';

@Component({
	selector: 'app-page-users-access',
	template: `
	    <ui-title [title]="'Users Access'"></ui-title>

	    <ui-loading [loading]="states.loadingUserAccess" [loadingText]="'loading user access'"></ui-loading>


	    <mat-accordion>
		    <mat-expansion-panel *ngFor="let kv of data.userAccess|kv">
			    <mat-expansion-panel-header>
				    <mat-panel-title>
						<span style="text-transform: capitalize">
							{{helper_formatGroupName(kv.key)}}
						</span>
				    </mat-panel-title>
				    <mat-panel-description>
				    </mat-panel-description>
			    </mat-expansion-panel-header>
			    <table class="table table-condensed">
				    <tr *ngFor="let row of kv.value">
					    <td class="col-lg-6">
						    {{row.Login}}
					    </td>
					    <td class="col-lg-6">
						    {{row.FullName}}
					    </td>
				    </tr>
			    </table>
		    </mat-expansion-panel>

	    </mat-accordion>


	    <br>
	    <ui-title [title]="'Approvers needing Access'"></ui-title>

	    <small>
		    Find approvers that have not been assigned to the Active Directory group of Approvers and therefor cannot report on QAR
	    </small>
	    <br>
	    <br>
	    <button class="btn btn-primary" (click)="findApproversMissingAccess()" *ngIf="!states.loadingMissingAccess">Find Approvers missing
		    Access
	    </button>


	    <ui-loading [loading]="states.loadingMissingAccess" [loadingText]="'please wait, this might take a few minutes'"></ui-loading>
	    <br>
	    <br>
	    <div *ngIf="states.loadingMissingAccessDone">
		    <ui-table #table [filters]="true" [chunker]="data.missingAccessChunker" (chunked)="data.missingAccess = $event" [paginationSize]="100">
			    <tr>
				    <th></th>
				    <th>Login</th>
				    <th>Name</th>
				    <th>Title</th>
				    <th>Department</th>
				    <th>Country</th>
				    <th>UPN</th>
				    <th>Is Active?</th>
				    <th>Subordinates</th>
			    </tr>
			    <tr *ngFor="let r of data.missingAccess">
				    <td class="red bold">{{r.IsOverriden == 'overriden' ? 'override' : ''}}</td>
				    <td>{{r.Login}}</td>
				    <td>{{r.FirstName}} {{r.LastName}}</td>
				    <td>{{r.Title}}</td>
				    <td>{{r.Department}}</td>
				    <td>{{r.Office}}</td>
				    <td>{{r.UserPrincipalName}}</td>
				    <td [class]="r.IsActive?'':'red bold'">{{r.IsActive ? 'Yes' : 'No'}}</td>
				    <td>
					    <table>
						    <tr *ngFor="let s of r.Subordinates">
							    <td>{{s.SystemName}}</td>
							    <td>{{s.UserName}}</td>
							    <td>{{s.RoleName}}</td>
						    </tr>
					    </table>
				    </td>
			    </tr>
		    </ui-table>
	    </div>

	    <br/>
	    <br/>
	    <br/>
	    <br/>
	`,
	providers: [QARService]
})
export class CheckApproversAccessPageComponent implements OnInit {

	constructor(public api: QARService) {
	}

	public data = {
		userAccess: [],
		missingAccess: [],
		missingAccessChunker: new Chunker([])
	};
	public states = {
		loadingUserAccess: false,
		loadingMissingAccess: false,
		loadingMissingAccessDone: false,
	};


	ngOnInit(): void {
		this.retrieveUsersAccess();
	}

	public findApproversMissingAccess() {
		this.states.loadingMissingAccess = true;
		this.api.findApproversMissingAccess().then(r => {
			this.data.missingAccessChunker = new Chunker(r);
			this.states.loadingMissingAccess = false;
			this.states.loadingMissingAccessDone = true;
		});
	}

	public retrieveUsersAccess() {
		this.states.loadingUserAccess = true;
		this.api.retrieveUsersAccess().then(r => {
			this.data.userAccess = r;
			this.states.loadingUserAccess = false;
		});
	}

	public helper_formatGroupName(g) {
		return g.replace('QARSOD_', '').replace('_', ' ').toLowerCase();
	}

}
